import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { WizardName } from '../../../types';
import { saveFormDataLocalStorage } from './formLocalStorage';

const FormikObserver: React.FC<{ wizardName: WizardName }> = ({ wizardName }) => {
    const { values } = useFormikContext();

    useEffect(() => {
        saveFormDataLocalStorage(wizardName, values);
    }, [values]);

    return null;
};

export default FormikObserver;
